const DEFAULT_POST_AUTH_REDIRECT = '/dashboard';
const MAX_REDIRECT_DECODE_PASSES = 8;

function hasUnsafeRedirectCharacters(value: string): boolean {
    for (const character of value) {
        const codePoint = character.codePointAt(0) || 0;
        if (character === '\\' || codePoint <= 0x1f || codePoint === 0x7f) {
            return true;
        }
    }
    return false;
}

export function isHomeRedirectPath(path: string): boolean {
    return path === '/' || path.startsWith('/?');
}

/**
 * Accept only local, root-relative destinations. Checking decoded forms closes
 * protocol-relative and backslash variants that a router or browser may
 * normalize after authentication.
 */
function isSafePostAuthRedirect(redirectTo: string): boolean {
    let candidate = redirectTo;

    for (let pass = 0; pass < MAX_REDIRECT_DECODE_PASSES; pass += 1) {
        if (
            !candidate.startsWith('/')
            || candidate.startsWith('//')
            || hasUnsafeRedirectCharacters(candidate)
        ) {
            return false;
        }

        let decoded: string;
        try {
            decoded = decodeURIComponent(candidate);
        } catch {
            return false;
        }

        if (decoded === candidate) {
            return true;
        }
        candidate = decoded;
    }

    // Fail closed if unusually deep encoding did not converge.
    return false;
}

export function normalizePostAuthRedirect(redirectTo?: string): string {
    if (!redirectTo || !isSafePostAuthRedirect(redirectTo)) {
        return DEFAULT_POST_AUTH_REDIRECT;
    }

    if (isHomeRedirectPath(redirectTo)) {
        return DEFAULT_POST_AUTH_REDIRECT;
    }

    return redirectTo;
}
